import React from 'react'

function Search({ original_menu, searchItems }) {

    const onChange = (event) => {
        const search = event.target.value;
        searchItems(search, original_menu);
    }
    return (
        <div className="col-12 mt-10">
            <div className="input-group">
                <input type="text" className="form-control items-search-box" placeholder="Search for items..." onChange={onChange} />
                <div className="input-group-append"><span className="input-group-text items-search-box-icon">
                    <i className="si si-magnifier"></i></span></div>
            </div>
        </div>
    )
}

export default Search;
